import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

export const upload = async (fleetTaskId, data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/attachment`,
    data,
  })

  return response?.data
}

export const remove = async (fleetTaskId, attachmentId) => {
  const response = await apiClientV2({
    method: 'DELETE',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/attachment/${attachmentId}`,
  })

  return response?.data
}